<div class="blog-section">


      <div class="container-fluid">
            <div class="row">
                  <div class="col-lg-7">
                        <div class="white-box">
                              <div class="table-title p-0">
                                    <h5>Create Blog</h5>
                              </div>
                              <hr>
                              <div class="content-block">
                                    <div class="form-modified">
                                          <div class="form-group row">
                                                <label for="staticEmail" class="col-sm-2 col-form-label">Blog Title
                                                      <span class="required">*</span></label>
                                                <div class="col-sm-10">
                                                      <label v-if="!Enable.Edit" for="staticEmail" class="readonly">{{Blog.Title}}</label> 
                                                      <input v-else type="text" id="inputPassword"
                                                            placeholder="Title" class="form-control" v-model="Blog.Title">
                                                </div>
                                          </div>

                                          <div class="form-group row">
                                                <label for="staticEmail" class="col-sm-2 col-form-label">Detail context
                                                      <span class="required">*</span></label>
                                                <div class="col-sm-10">
                                                      <label v-if="!Enable.Edit" for="staticEmail" class="readonly">{{Blog.Content}}</label> 
                                                      <textarea v-else name="" id="" cols="30" rows="7"
                                                            placeholder="Description" v-model="Blog.Content"></textarea>
                                                </div>
                                          </div>

                                          <div class="form-group row" v-if="!Blog.Image">
                                                <label for="staticEmail" class="col-sm-2 col-form-label">Blog image<span
                                                            class="required">*</span></label>
                                                <div class="col-sm-10">
                                                      <div class="custom-file mb-3"><input type="file"
                                                                  id="customDocument" accept="image/*"
                                                                  class="custom-file-input"> <label for="customDocument"
                                                                  class="custom-file-label">Browse Image</label></div>
                                                </div>

                                          </div>
                                          <div class="form-group row">
                                                <label for="staticEmail" class="col-sm-2 col-form-label">Image alt text
                                                      <span class="required">*</span></label>
                                                <div class="col-sm-10">
                                                      <label v-if="!Enable.Edit" for="staticEmail" class="readonly">{{Blog.ImageAltText}}</label> 
                                                      <input v-else type="text" id="inputPassword"
                                                            placeholder="Destination name" class="form-control" v-model="Blog.ImageAltText">
                                                </div>
                                          </div>
                                          <div class="form-group row">
                                                <label for="staticEmail" class="col-sm-2 col-form-label">Other
                                                      options<span class="required">*</span></label>
                                                <div class="col-sm-10">
                                                      <!-- <label for="staticEmail" class="readonly">Poonhill Tea House Trek 7-Days</label>  -->
                                                      <div class="row">
                                                            <div class="col-lg-6">
                                                                  <div class="checkbox-block">
                                                                        <div class="form-check pl-0"><input
                                                                                    type="checkbox" id="checkbox"
                                                                                    class="form-check-input mt-0" v-model="Show.TagCategory" @change="checkTags">
                                                                              <label for="exampleCheck1"
                                                                                    class="form-check-label pl-4">Add
                                                                                    tags & categories</label></div>
                                                                        <!---->
                                                                  </div>
                                                            </div>
                                                            <div class="col-lg-6">
                                                                  <div class="checkbox-block">
                                                                        <div class="form-check pl-0"><input
                                                                                    type="checkbox" id="checkbox"
                                                                                    class="form-check-input mt-0" v-model="Show.MultiTags" @change="checkMultiTags">
                                                                              <label for="exampleCheck1"
                                                                                    class="form-check-label pl-4">Add
                                                                                    meta & og tags</label></div>
                                                                        <!---->
                                                                  </div>
                                                            </div>
                                                      </div>
                                                </div>
                                          </div>


                                          <div class="content-block">
                                                <div class="row">
                                                      <div class="col-lg-8 offset-lg-2">
                                                            <button class="btn default-btn" type="submit">Save</button>
                                                            <button class="btn default-btn cancel"
                                                                  type="submit">Cancel</button>
                                                      </div>
                                                </div>

                                          </div>


                                          <div class="content-block">
                                                <div class="row">
                                                      <div class="col-md-10 offset-md-2">

                                                      </div>
                                                </div>
                                          </div>
                                    </div>
                              </div>
                        </div>
                  </div>
                  <div class="col-lg-5">
                        <div class="white-box mb-4" v-if="Show.TagCategory">
                              <div class="form-modified">
                                    <div class="form-group row">
                                          <label for="staticEmail" class="col-sm-2 col-form-label">Tags<span
                                                      class="required">*</span></label>
                                          <div class="col-sm-10">
                                                <!-- <label for="staticEmail" class="readonly">Poonhill Tea House Trek 7-Days</label>  -->
                                                <input type="text" id="inputPassword" placeholder="Tags"
                                                      class="form-control">
                                          </div>
                                    </div>
                                    <div class="form-group row">
                                          <label for="staticEmail" class="col-sm-2 col-form-label">Categories<span
                                                      class="required">*</span></label>
                                          <div class="col-sm-10">
                                                <!-- <label for="staticEmail" class="readonly">Poonhill Tea House Trek 7-Days</label>  -->
                                                <input type="text" id="inputPassword" placeholder="Categories"
                                                      class="form-control">
                                          </div>
                                    </div>
                              </div>

                              <div class="text-lg-right">

                                    <button class="btn default-btn" type="submit">Save</button>
                                    <button class="btn default-btn cancel" type="submit">Cancel</button>
                              </div>



                        </div>
                        <div class="white-box" v-if="Show.MultiTags">
                              <div class="blog-tab-block">
                                    <ul class="nav nav-tabs" id="myTab" role="tablist">
                                          <li class="nav-item">
                                                <a class="nav-link active" id="meta-tag" data-toggle="tab" href="#home"
                                                      role="tab" aria-controls="home" aria-selected="true">Meta tags</a>
                                          </li>
                                          <li class="nav-item">
                                                <a class="nav-link" id="og-tag" data-toggle="tab" href="#profile"
                                                      role="tab" aria-controls="profile" aria-selected="false">Og
                                                      tags</a>
                                          </li>

                                    </ul>
                                    <div class="tab-content" id="myTabContent">
                                          <div class="tab-pane fade show active" id="home" role="tabpanel"
                                                aria-labelledby="meta-tag">
                                                <div class="tab-content-block">
                                                      <div class="form-modified">
                                                            <div class="form-group row">
                                                                  <label for="staticEmail"
                                                                        class="col-sm-3 col-form-label">Meta title <span
                                                                              class="required">*</span></label>
                                                                  <div class="col-sm-9">
                                                                        <!-- <label for="staticEmail" class="readonly">Poonhill Tea House Trek 7-Days</label>  -->
                                                                        <input type="text" id="inputPassword"
                                                                              placeholder="Destination name"
                                                                              class="form-control">
                                                                  </div>
                                                            </div>

                                                            <div class="form-group row">
                                                                  <label for="staticEmail"
                                                                        class="col-sm-3 col-form-label">Meta
                                                                        description<span
                                                                              class="required">*</span></label>
                                                                  <div class="col-sm-9">
                                                                        <!-- <label for="staticEmail" class="readonly">Poonhill Tea House Trek 7-Days</label>  -->
                                                                        <textarea name="" id="" cols="30" rows="3"
                                                                              placeholder="Description"></textarea>
                                                                  </div>
                                                            </div>
                                                            <div class="form-group row">
                                                                  <label for="staticEmail"
                                                                        class="col-sm-3 col-form-label">Keyword<span
                                                                              class="required">*</span></label>
                                                                  <div class="col-sm-9">
                                                                        <!-- <label for="staticEmail" class="readonly">Poonhill Tea House Trek 7-Days</label>  -->
                                                                        <textarea name="" id="" cols="30" rows="2"
                                                                              placeholder="Description"></textarea>
                                                                  </div>
                                                            </div>
                                                      </div>
                                                      <div class="text-lg-right">

                                                            <button class="btn default-btn" type="submit">Save</button>
                                                            <button class="btn default-btn cancel"
                                                                  type="submit">Cancel</button>
                                                      </div>
                                                </div>

                                          </div>
                                          <div class="tab-pane fade" id="profile" role="tabpanel"
                                                aria-labelledby="og-tag">
                                                <div class="tab-content-block">
                                                      <div class="form-modified">
                                                            <div class="form-group row">
                                                                  <label for="staticEmail"
                                                                        class="col-sm-3 col-form-label">Og title <span
                                                                              class="required">*</span></label>
                                                                  <div class="col-sm-9">
                                                                        <!-- <label for="staticEmail" class="readonly">Poonhill Tea House Trek 7-Days</label>  -->
                                                                        <input type="text" id="inputPassword"
                                                                              placeholder="Destination name"
                                                                              class="form-control">
                                                                  </div>
                                                            </div>

                                                            <div class="form-group row">
                                                                  <label for="staticEmail"
                                                                        class="col-sm-3 col-form-label">Og
                                                                        description<span
                                                                              class="required">*</span></label>
                                                                  <div class="col-sm-9">
                                                                        <!-- <label for="staticEmail" class="readonly">Poonhill Tea House Trek 7-Days</label>  -->
                                                                        <textarea name="" id="" cols="30" rows="3"
                                                                              placeholder="Description"></textarea>
                                                                  </div>
                                                            </div>
                                                            <div class="form-group row">
                                                                  <label for="staticEmail"
                                                                        class="col-sm-3 col-form-label">Og url<span
                                                                              class="required">*</span></label>
                                                                  <div class="col-sm-9">
                                                                        <!-- <label for="staticEmail" class="readonly">Poonhill Tea House Trek 7-Days</label>  -->
                                                                        <textarea name="" id="" cols="30" rows="2"
                                                                              placeholder="Description"></textarea>
                                                                  </div>
                                                            </div>
                                                      </div>
                                                      <div class="text-lg-right">

                                                            <button class="btn default-btn" type="submit">Save</button>
                                                            <button class="btn default-btn cancel"
                                                                  type="submit">Cancel</button>
                                                      </div>
                                                </div>
                                          </div>

                                    </div>
                              </div>

                        </div>
                  </div>
            </div>

      </div>

</div>